import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./mobi.png"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Mobiklinic Uganda</div>
							<div className="work-subtitle">
								Full-Stack Software Engineer
							</div>
							<div className="work-duration">2023 - Present</div>
						</div>

						<div className="work">
							<img
								src="./edu.png"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">
								Wikipedia WikiEduDashboard
							</div>
							<div className="work-subtitle">
								Open Source Developer
							</div>
							<div className="work-duration">2022 - Present</div>
						</div>

						<div className="work">
							<img
								src="./rtl.png"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">
								Rootless Technologies
							</div>
							<div className="work-subtitle">
								Part-Time Software Engineer
							</div>
							<div className="work-duration">2023 - Present</div>
						</div>
						<div className="work">
							<img
								src="./ag.jpg"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">Agalm Technologies</div>
							<div className="work-subtitle">
								Backend Engineer
							</div>
							<div className="work-duration">2021 - 2023</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
